




















































































































































































import { defineComponent } from "@vue/composition-api";

import {
  formKeyLabelList,
  formPlaceholderList,
  formDescriptionList
} from "@/helpers/official";
import { OFFICIAL_STORE_KEY } from "@/helpers/hooks/useOfficial";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";

import InputFieldGroup from "@/components/Organisms/InputFieldGroup/index.vue";
import InputField from "@/components/Organisms/InputField/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import FieldAddButton from "@/components/Atoms/Forms/FieldAddButton/index.vue";
import EmptyView from "@/components/Atoms/EmptyView/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";

export default defineComponent({
  components: {
    InputFieldGroup,
    InputField,
    TextField,
    TextArea,
    FieldAddButton,
    EmptyView,
    OccHeading
  },
  name: "MovieForm",
  setup() {
    const {
      isPendingVersion,
      officialEditingForm,
      onSetForm,
      getOfficialErrorMessage,
      getOfficialWarnMessage,
      addOfficialContent,
      deleteOfficialContent,
      changeOrderOfficialContents
    } = useGlobalState(OFFICIAL_STORE_KEY);

    return {
      // official.tsのヘルパー関連
      formKeyLabelList,
      formPlaceholderList,
      formDescriptionList,

      // ストア関連
      isPendingVersion,
      officialEditingForm,
      onSetForm,
      getOfficialErrorMessage,
      getOfficialWarnMessage,
      addOfficialContent,
      deleteOfficialContent,
      changeOrderOfficialContents
    };
  }
});
